<template>
  <div class="textarea" :class="textAreaModifiers">
    <label class="textarea__label" :for="name">
      <div class="textarea__placeholder">{{ placeholder }}<span v-if="required">*</span></div>
      <textarea
        class="textarea__value"
        :disabled="disabled"
        :name="name"
        :id="name"
        :maxlenght="maxLength"
        :value="modelValue"
        @input="updateValue"
        @blur="handleBlur"
        @focus="handleFocus"
      ></textarea>
    </label>
  </div>
</template>
<script src="./textarea.js"></script>
<style src="./textarea.scss" lang="scss"></style>
